// Single source of truth for official company contact details. Never type the number anywhere else.
export const COMPANY = {
  legalName: "AuraMax Ventures LLC",
  brand: "AuraMax",
  phoneDisplay: "(908) 512-7477",
  phoneIntl: "+1 908-512-7477",
  phoneTel: "tel:+19085127477",
  website: "https://auramax.dev",
  xUrl: "https://x.com/auramaxapp",
  availability: "Leave a message — we respond as soon as possible.",
};
